import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles<{
  isHorizontal: boolean;
  closeButtonStyle?: boolean;
}>({
  name: 'ActionModal',
})(
  (
    {
      aspectRatio,
      typography: { pxToRem },
      breakpoints,
      brandColors,
      spacing,
      type,
    },
    props
  ) => ({
    closeButton: {
      zIndex: 1,
      position: 'absolute',
      top: pxToRem(10),
      right: pxToRem(14),

      [breakpoints.up('sm')]: {
        top: pxToRem(16),
        right: pxToRem(18),
      },
    },
    closeIcon: {
      color: props.closeButtonStyle
        ? brandColors.white
        : brandColors.tintsNeutral20,
      [breakpoints.up('md')]: {
        color: props.isHorizontal
          ? brandColors.tintsNeutral20
          : props.closeButtonStyle
            ? brandColors.tintsNeutral20
            : brandColors.white,
      },
    },
    content: {
      borderRadius: pxToRem(16),
      overflow: 'hidden',
      backgroundColor: brandColors.tintsOffWhite60,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'white',
      outline: 0,
      width: pxToRem(300),
      maxHeight: 'calc(100dvh - 32px)',
      display: 'flex',
      flexDirection: 'column',

      [breakpoints.up('sm')]: {
        width: pxToRem(600),
        maxHeight: 'calc(100dvh - 64px)',
        minHeight: `min(${pxToRem(640)}, calc(100dvh - 64px))`,
      },
    },
    horizontalContent: {
      [breakpoints.up('md')]: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: '1fr',
        width: pxToRem(800),
        minHeight: pxToRem(640),
      },
    },
    imageContainer: {
      flex: '0 0 auto',
      position: 'relative',
      width: '100%',
      height: '100%',
      aspectRatio: aspectRatio['16/9'],

      [breakpoints.up('md')]: {
        aspectRatio: props.isHorizontal ? 'unset' : aspectRatio['16/9'],
      },
    },
    contentContainer: {
      flex: '1 1 auto',
      minHeight: 0,
      overflowY: 'auto',
      padding: `${spacing(2)} ${spacing(0)}`,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),

      [breakpoints.up('sm')]: {
        padding: spacing(2),
        gap: spacing(1),
      },

      [breakpoints.up('md')]: {
        gap: props.isHorizontal ? spacing(2) : spacing(1),
      },
    },
    image: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      zIndex: -1,

      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    heading: {
      color: brandColors.primaryMain,
      ...type['32_medium'],
      textWrap: 'pretty',

      [breakpoints.up('sm')]: {
        ...type['56_medium'],
      },
    },
    headingSm: {
      ...type['24_medium'],

      [breakpoints.up('sm')]: {
        ...type['32_medium'],
      },
    },
    subheading: {
      '&& *': {
        ...type['14_regular'],
      },

      [breakpoints.up('sm')]: {
        '&& *': {
          ...type['18_regular'],
        },
      },
    },
    termsAndConditions: {
      '&& *': {
        ...type['12_regular'],
        color: `${brandColors.tintsNeutral20}`,
      },
      '&& p:not(:last-child)': {
        marginBottom: spacing(0),
      },
    },
    verticalGapZero: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(0),
    },
    cta: {
      width: '100%',
    },
    secondaryCTA: {
      alignSelf: 'center',
      padding: `0 ${spacing(-1)}`,
      textDecoration: 'underline',
    },
  })
);

export default useStyles;
